import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockFeedbackComponent } from '@app/components/blocks/block-feedback/block-feedback.component';
import { FeedbackModule } from '@app/components/feedback/feedback.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, FeedbackModule],
  declarations: [BlockFeedbackComponent],
  exports: [BlockFeedbackComponent],
})
export class BlockFeedbackModule {}
